const replaceIdInTree = (tree, replaceId, withId) => {
  if (tree.id === replaceId) {
    return tree.set("id", withId);
  }
  return tree.update("children", children => children.map(c => replaceIdInTree(c, replaceId, withId)));
};

export default replaceIdInTree;
